import React from "react";
import GlobalStyles from "styles/GlobalStyles";
import { useTranslation } from "react-i18next";
import "./i18n";
import {
	BrowserRouter as Router,
	Route,
	Routes,
	Navigate,
	useParams,
} from "react-router-dom";
import Header from "components/Header/Header";

// Import sections
import {
	SimpleFiveColumnFooter,
	AboutComponent,
	MiniCenteredFooter,
} from "./Components";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import ThreeColContactDetails from "components/cards/ThreeColContactDetails";
import BackgroundAsImage from "components/hero/BackgroundAsImage";
import ThreeColWithSideImage from "components/features/ThreeColWithSideImage";
import TwoColumnPrimaryBackground from "components/faqs/TwoColumnPrimaryBackground";

// A function to change the language dynamically
const LanguageRouterWrapper = ({ children }) => {
	const { i18n } = useTranslation();
	const { lng } = useParams();

	// When the route changes, update the language in i18next
	React.useEffect(() => {
		if (lng && lng !== i18n.language) {
			i18n.changeLanguage(lng); // Set the language based on the route
		}
	}, [lng, i18n]);

	return children;
};

function App() {
	return (
		<Router>
			<GlobalStyles />
			<Header />
			<AnimationRevealPage disabled={false}>
				<Routes>
					{/* Default route to redirect to Armenian if no language is specified */}
					<Route path="/" element={<Navigate to="/hy" />} />
					{/* Wrap language routes in a component to handle dynamic language changes */}
					<Route
						path="/:lng"
						element={
							<LanguageRouterWrapper>
								<div>
									{/* Hero Section */}
									<section id="home">
										<BackgroundAsImage />
									</section>
									<section id="services">
										<ThreeColContactDetails />
									</section>
									{/* About Section */}
									<section id="practice">
										<ThreeColWithSideImage />
									</section>
									<section id="about">
										<AboutComponent />
									</section>
									{/* Footer Section */}
									<section id="expertise">
										<TwoColumnPrimaryBackground />
									</section>
									<section id="contact">
										<MiniCenteredFooter />
									</section>
								</div>
							</LanguageRouterWrapper>
						}
					/>
				</Routes>
			</AnimationRevealPage>
		</Router>
	);
}

export default App;
